(function () {
  if (window.__stnTimerInit) return;
  window.__stnTimerInit = true;

  function secondsLeft() {
    var parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Paris', hour12: false,
      hour: '2-digit', minute: '2-digit', second: '2-digit'
    }).formatToParts(new Date());
    var g = function (t) {
      var p = parts.find(function (x) { return x.type === t; });
      return p ? parseInt(p.value, 10) : 0;
    };
    var h = g('hour') % 24;
    return 86400 - (h * 3600 + g('minute') * 60 + g('second'));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function tick() {
    var els = document.querySelectorAll('.stn-timer');
    if (!els.length) return;
    var s = secondsLeft();
    var txt = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor((s % 3600) / 60)) + ':' + pad(s % 60);
    els.forEach(function (el) { el.textContent = txt; });
  }

  function start() { tick(); setInterval(tick, 1000); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  document.addEventListener('shopify:section:load', tick);
})();